import { api } from '../../utils/api';

export const getUser = async (id) => {
    try {
        const response = await api.get(`register-general/${id}`);
        return response.data
    } catch (e) {
        return e.response.data;
    }
}